import { QueryClient, QueryClientProvider as ReactQueryClientProvider } from '@tanstack/react-query';
import { FC, PropsWithChildren } from 'react';

const queryClient = new QueryClient();

export const QueryClientProvider: FC<PropsWithChildren> = ({ children }) => (
  <ReactQueryClientProvider client={queryClient}>{children}</ReactQueryClientProvider>
);
